module.exports = __webpack_public_path__ + "static/rivercitylabs-81926e81527193083fbf50abbd0ff940.svg";